import { render, staticRenderFns } from "./ModifyCompensatoryService.vue?vue&type=template&id=bfc715cc&scoped=true"
import script from "./ModifyCompensatoryService.vue?vue&type=script&lang=js"
export * from "./ModifyCompensatoryService.vue?vue&type=script&lang=js"
import style0 from "./ModifyCompensatoryService.vue?vue&type=style&index=0&id=bfc715cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc715cc",
  null
  
)

export default component.exports